import {css} from '@emotion/css';
import {coloursV2, darken, spacing} from '@fo/shared/styles/variables';

export default {
  menuButton: css`
    label: NavigationUserMenuMobile__menuButton;
    && {
      display: flex;
      justify-content: space-between;
      padding: ${spacing.XS};
      width: 100%;
      border-radius: unset;
    }
    border-bottom: 1px solid ${darken(coloursV2.background.lightGray)};
  `,
  menuButtonText: css`
    label: headerMainBar__menuButtonText;
    margin-right: ${spacing.XXXS};
  `,

  linksContainer: (isOpen: boolean): string => css`
    label: NavigationUserMenuMobile__linksContainer;
    padding: ${spacing.XXS};
    ${isOpen
      ? css`
          display: flex;
          flex-direction: column;
        `
      : css`
          display: none;
        `}
  `,
  loginButton: css`
    label: NavigationUserMenuMobile__loginButton;
    display: flex;
    justify-content: center;
    padding: ${spacing.XS} ${spacing.XXS};
    && {
      width: 100%;
    }
    border-radius: unset;
  `,
  linkButton: css`
    label: NavigationUserMenuMobile__linkButton;
    display: flex;
    justify-content: flex-start;
    padding: ${spacing.XXS};
    color: ${coloursV2.font.black};
    text-decoration: none;
    text-align: left;
  `,
  icon: css`
    label: NavigationUserMenuMobile__icon;
    width: 1.4rem;
    height: 2.4rem;
    color: ${coloursV2.font.grey};
    margin-right: ${spacing.XS};
  `,
  text: css`
    label: NavigationUserMenuMobile__text;
    margin-top: 0.2rem;
  `,
  userName: css`
    label: NavigationUserMenuMobile__userName;
    margin-left: -0.75rem;
  `,
};
